import { render, staticRenderFns } from "./WidgetSettingsDialog.vue?vue&type=template&id=11fcdb16&scoped=true"
import script from "./WidgetSettingsDialog.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettingsDialog.vue?vue&type=style&index=0&id=11fcdb16&prod&lang=css"
import style1 from "./WidgetSettingsDialog.vue?vue&type=style&index=1&id=11fcdb16&prod&scoped=true&lang=css"
import style2 from "./WidgetSettingsDialog.vue?vue&type=style&index=2&id=11fcdb16&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fcdb16",
  null
  
)

export default component.exports